<div class="displayTable">
  <div class="login-logo">
    <img src="./assets/image/ancytree.logo.png" alt="">
  </div>
  <div class="displayTableCell">
    <div class="authBlock">
      <h2 i18n class="text-center">Sign Up</h2>
      <!-- <label i18n for="firstName">First Name</label>
      <input class="formControl" #userFirstname required />
      <label i18n for="lastName">Last Name</label>
      <input class="formControl" #userLastName required /> -->
      <div class="input-group">
        <label i18n for="email">Email Address</label>
        <input type="email" class="formControl" #userEmail required />
      </div>
      <!-- <label i18n for="country">Country</label>
      <select formControlName="country" #userCountry>
        <option i18n *ngFor="let item of countries" [value]="item.country">{{item.country}}
        </option>
      </select>  -->
      <div class="input-group">
        <label i18n for="password">Password</label>
        <div class="password-container">
          <input matInput name="password" [type]="passwordVisible ? 'text' : 'password'" id="password" class="formControl" #userPwd required />
          <mat-icon (click)="this.passwordVisible = !this.passwordVisible">{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
        </div>
      </div>

      <div class="formGroup sign-up-button-container">
        <button i18n type="button" class="button-group sign-up-button"
          (click)="authService.SignUp(userEmail.value, userPwd.value)">Sign Up</button>
      </div>

      <div class="formGroup text-center">
        <span i18n class="or"><span class="orInner">Or</span></span>
      </div>
      <div>
        <!-- Continue with Google -->
        <div class="social">
          <button i18n type="button" class="btn googleBtn" (click)="authService.GoogleAuth()">
            <i class="fab fa-google-plus-g"></i>
            Continue with Google
          </button>
        </div>
        <!-- Continue with Facebook -->
        <!-- <div class="social">
          <button i18n type="button" class="btn facebookBtn" (click)="authService.FacebookAuth()">
            <i class="fab fa-facebook"></i>
            Continue with Facebook
          </button>
        </div> -->
      </div>

      <div class="redirectToLogin">
        <span class="text-container">
          <p i18n>Already have an account? 
            <a  class="redirect" routerLink="/sign-in">Log In</a>
          </p>
        </span>
      </div>
    </div>
  </div>
</div>